import axios from 'axios'
import type { Route, Stop } from './types'

export interface CalcResult { stops: Stop[]; totalDistance: number; totalTime: number }

export const calculateRoute = async (route: Route & { returnToStart?: boolean }): Promise<CalcResult> => {
  // Post the whole route (Vue posts `{ ...route }`) so the backend sees every
  // field it may read — vehicle, stops (incl. depot hubs carrying the shift
  // start/end), driver, returnToStart — not just a hand-picked subset.
  const res = await axios.post(process.env.REACT_APP_CALCULATE_ROUTES as string, {
    ...route, returnToStart: route.returnToStart ?? false,
  })
  return { stops: res.data.stops ?? route.stops, totalDistance: res.data.totalDistance ?? 0, totalTime: res.data.totalTime ?? 0 }
}
